import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useParams, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";
import axios from "axios";
import { useUser } from "../../../context/UserContext"; // Ensure this provides { user }
import ImageOffcanvas from "./ImageOffcanvas";
import StarRating from "./StarRating";
import { FaStar } from "react-icons/fa";


const VideoView = () => {
  const { user } = useUser();
  const isLoggedIn = !!user;
  const { link, topic, vid_id } = useParams();
  const navigate = useNavigate();
  const playerRef = useRef();
  const [isPlaying, setIsPlaying] = useState(false);
  const [watchTime, setWatchTime] = useState(0);
  const [previousWatchTime, setPreviousWatchTime] = useState(0);
  const [totalWatchTime, setTotalWatchTime] = useState(0);
  const secretKey = "sachin";
  const MAX_WATCH_SECONDS = 18000; // 5 hours

  const [rating, setRating] = useState(0);
  const [avgRating, setAvgRating] = useState(0);
   const [totalUsers, setTotalUsers] = useState(0);

  const [loading, setLoading] = useState(true);

  /* ---------- GET RATING API ---------- */
  useEffect(() => {
    if (!user || !vid_id) return;

    fetch(
      `https://topfaculty.co.in/api/get_video_rating.php?user_id=${user.user_id}&video_id=${vid_id}`,
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("GET Rating:", data);
        if (data.status === true) {
          setRating(data.rating); // ⭐ auto fill
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [user, vid_id]);

  /* ---------- SUBMIT / UPDATE RATING ---------- */
  const handleRatingSubmit = async (selectedRating) => {
    const payload = {
      user_id: user.user_id,
      video_id: vid_id,
      rating: selectedRating,
    };

    const res = await fetch("https://topfaculty.co.in/api/video_ratings.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (data.status === true) {
      alert("Rating saved ⭐");
    } else {
      alert(data.message);
    }
  };

  //AVRAGE RATING FETCH
useEffect(() => {
    fetch(`https://topfaculty.co.in/api/get_video_rating_avg.php?video_id=${vid_id}`)
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          setAvgRating(data.avg_rating);
          setTotalUsers(data.total_users);
        }
      })
      .catch(err => console.error("Rating fetch error:", err));
  }, [vid_id]);
  // if (!user) return null;
  // if (loading) return <p>Loading rating...</p>;

  // const handleRatingSubmit = async (selectedRating) => {
  //   if (!selectedRating) return;

  //   const payload = {
  //     user_id: user.user_id,     // replace with real logged-in user id
  //     video_id: vid_id,   // replace with current video id
  //     rating: selectedRating,
  //   };

  //   try {
  //     const res = await fetch(
  //       "https://topfaculty.co.in/api/video_ratings.php",
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(payload),
  //       }
  //     );

  //     const data = await res.json();

  //     console.log("Rating Response:", data);
  //     if (data.status) {
  //       alert("Rating submitted successfully ⭐");
  //     } else {
  //       alert(data.message);
  //     }
  //   } catch (err) {
  //     alert("Something went wrong");
  //   }
  // };

  // encryption key used for video links
  const decryptedFilename = (() => {
    try {
      const bytes = CryptoJS.AES.decrypt(decodeURIComponent(link), secretKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Failed to decrypt video link:", error);
      return "";
    }
  })();

  const totalTime = previousWatchTime + watchTime;
  const fulwatch = totalWatchTime + watchTime;
  // console.log("USERrrrl;kjndfkjcnkdjsnkjndskj:", user.user_name);
  // Fetch previous video time and total time
  useEffect(() => {
    if (!isLoggedIn || !decryptedFilename) return;
    axios
      .get("https://topfaculty.co.in/api/get-watch-time.php", {
        params: {
          user_id: user.user_id,
          user_name: user.user_name,
          video_url: decryptedFilename,
        },
      })
      .then((res) => {
        console.log("Watch Data:", res.data);
        setPreviousWatchTime(res.data.watched_seconds || 0);
        setTotalWatchTime(res.data.total_watch || 0);
      })
      .catch((err) => {
        console.error("Failed to fetch watch time", err);
      });
  }, [decryptedFilename, user]);

  // Increment watch time if playing
  useEffect(() => {
    let interval = null;
    if (isLoggedIn && isPlaying && totalWatchTime < MAX_WATCH_SECONDS) {
      interval = setInterval(() => {
        setWatchTime((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isPlaying, totalWatchTime, isLoggedIn]);

  // Save watch time every 10 seconds
  useEffect(() => {
    if (!isLoggedIn || watchTime === 0) return;
    const saveInterval = setInterval(() => {
      const payload = {
        user_id: user.user_id,
        user_name: user.user_name,
        video_url: decryptedFilename,
        watched_seconds: watchTime + previousWatchTime,
      };
      console.log("Payload:", payload);

      axios
        .post("https://topfaculty.co.in/api/save-watch-time.php", payload)
        .then((res) => {
          console.log("Time saved:", res.data);
        })
        .catch((err) => {
          console.error("Failed to save watch time", err);
        });
    }, 1000);
    return () => clearInterval(saveInterval);
  }, [watchTime, previousWatchTime, decryptedFilename, user]);

  const handlePlay = () => {
    if (!isLoggedIn) {
      Swal.fire("Login Required", "Please login to continue.", "info").then(
        () => navigate("/studentlogin"),
      );
      return;
    }

    if (totalWatchTime >= MAX_WATCH_SECONDS) {
      Swal.fire("Limit Reached", "You have watched 5 hours total.", "warning");
      setIsPlaying(false);
    } else {
      setIsPlaying(true);
    }
  };

  const handlePause = () => {
    setIsPlaying(false);
  };

  // const handleProgress = (state) => {
  //   // Optional: block anonymous users after 20s preview
  //   if (!isLoggedIn && state.playedSeconds > 5) {
  //     setIsPlaying(false);
  //     Swal.fire(
  //       "Login Required",
  //       "Please login to watch full video.",
  //       "info"
  //     ).then(() => navigate("/studentlogin"));
  //   }

  // };

  const handleProgress = (state) => {
    // 1. Block guest users after preview
    if (!isLoggedIn && state.playedSeconds > 10) {
      setIsPlaying(false);
      Swal.fire(
        "Login Required",
        "Please login to watch full video.",
        "info",
      ).then(() => navigate("/studentlogin"));
      return;
    }

    // 2. If logged in AND watched over 5 hours, block playback
    if (isLoggedIn && fulwatch >= 18000) {
      setIsPlaying(false);
      Swal.fire(
        "Package Expired",
        "Your video access is limited to 5 hours. Please purchase a new package.",
        "warning",
      ).then(() => navigate("/our-batches"));
      return;
    }
  };
  console.log("Total Watch:", fulwatch);

  // REMAINING TIME
  const FIVE_HOURS_IN_SECONDS = 5 * 60 * 60; // 18000

  const remainingSeconds = FIVE_HOURS_IN_SECONDS - fulwatch;

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return `${h}h ${m}m ${s}s`;
  };

  return (
    <div id="rs-latest-news" className="rs-latest-news ">
      <img
        src="assetsfront/images/wvid.jpg"
        alt="student registration"
        style={{
          marginTop: "0%",
          width: "100%",
          // height: "200px",
          objectFit: "cover",
        }}
      />
      <div className="container">
        <div className="sec-title mt-4 mb-3 text-center">
          <h2>
            Topic: <span className="info-color">{topic}</span>
          </h2>
          <div className="d-flex justify-content-center my-3">
      <div
        className="px-3 py-2 rounded-4 shadow-sm d-inline-flex align-items-center gap-2"
        style={{
          background: "#fff",
          border: "1px solid #f1f1f1",
        }}
      >
        {/* ⭐ Avg Badge */}
        <span
          className="badge d-flex align-items-center gap-1 px-2 py-1"
          style={{
            background: "#ffc107",
            position: "static",
            color: "#000",
            fontSize: "13px",
            fontWeight: "600",
          }}
        >
          <FaStar size={12} />
          {avgRating.toFixed(1)}
        </span>

        {/* ⭐ Stars */}
        <div className="d-flex gap-1">
          {[1, 2, 3, 4, 5].map((star) => (
            <FaStar
              key={star}
              size={14}
              style={{
                transition: "0.3s",
                color:
                  star <= Math.round(avgRating)
                    ? "#ffc107"
                    : "#e4e5e9",
              }}
            />
          ))}
        </div>

        {/* 👥 Users */}
        <small className="text-muted fw-semibold">
          ({totalUsers} ratings)
        </small>
      </div>
    </div>
          <ImageOffcanvas />
          {/* {isLoggedIn && (
            <p className="mb-4">
              Total Watch Time: <strong>{formatTime(totalTime)}</strong> / 20h
            </p>
          )} */}
          
          {isLoggedIn && (
            <>
              <p className="mb-1">
                ⌚ This Video Watch Time:{" "}
                <strong>{formatTime(totalTime)}</strong>
              </p>
              <p>
                👁️ Total Watch Time: <strong>{formatTime(fulwatch)}</strong>
              </p>
              <p style={{ color: "red", fontWeight: "900" }}>
                Expire : <strong>{formatTime(remainingSeconds)}</strong>
              </p>
            </>
          )}

          
        </div>
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
            
            <div
              className="news-normal-block"
              style={{ height: "100%", border: "5px solid rgb(0 35 102)" }}
            >
              
              <div className="custom-player-wrapper">
                <ReactPlayer
                  ref={playerRef}
                  url={decryptedFilename}
                  controls={true}
                  playing={isPlaying}
                  width="100%"
                  height="100%"
                  className="react-player"
                  light="/assetsfront/images/thub1.png"
                  onClickPreview={handlePlay}
                  onPlay={handlePlay}
                  onPause={handlePause}
                  onProgress={handleProgress}
                  config={{
                    file: {
                      attributes: {
                        controlsList: "nodownload",
                        disablePictureInPicture: true,
                      },
                    },
                  }}
                />
              </div>
            </div>









            {isLoggedIn && (
              <>
                <StarRating
                  rating={rating}
                  setRating={setRating}
                  onSubmit={handleRatingSubmit}
                />
              </>
            )}
          </div>
          <div className="col-md-2"></div>
        </div>
      </div>
    </div>
  );
};

export default VideoView;
